import { Cache } from "memory-cache";
import { CharacterPlanetDetailEntity } from ".";

// Cache
const cache = new Cache();
export async function getCachedCharacterPlanetDetailEntity(
  character_id: number,
  planet_id: number
): Promise<CharacterPlanetDetailEntity | null> {
  let entity: any = await cache.get("planetdetail-" + character_id.toString() + "-" + planet_id.toString());
  if (entity) {
    return entity;
  }
  return null;
}
export function setCachedCharacterPlanetDetailEntity(char_id: number, planet: CharacterPlanetDetailEntity) {
  cache.put("planetdetail-" + char_id + "-" + planet.props.id, planet, 60 * 60 * 1000 /* 1 hour */);
}
